import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { environment as envProd } from '../../../../environments/environment.prod';
import { ConfigService } from '../../../config/config.service';

@Injectable()
export class AppConfigService {
  public WEB_CALL_SCRIPT_URL: string;
  public IFRAME_ADDRESS: string;
  public WEB_CALL_BACKEND_CONFIGURATOR_URL: string;
  public CRAZYCALL_BACKEND_URL: string;
  public APP_ID: string;
  public ENVIRONMENT: string;

  constructor(private configService: ConfigService) {
    const env = this.isProd(configService.backendUrl) ? envProd : environment;

    this.ENVIRONMENT = env.LEAD_GENERATION_ENV;
    this.WEB_CALL_SCRIPT_URL = env.WEB_CALL_SCRIPT_URL;
    this.IFRAME_ADDRESS = env.IFRAME_ADDRESS;
    this.WEB_CALL_BACKEND_CONFIGURATOR_URL = env.WEB_CALL_BACKEND_CONFIGURATOR_URL;
    this.CRAZYCALL_BACKEND_URL = env.CRAZYCALL_BACKEND_URL;
    this.APP_ID = env.APP_ID;
  }

  isProd(backendUrl: string): boolean {
    return backendUrl === 'https://backend.crazycall.com';
  }
}
